import React from 'react';

import { TableHeaderProps, TotalItemsLabel } from '@/components';
import { TableHeaderLayout } from '@/layouts';

export const FoodsAndProductsTableHeader = ({
  count,
  selectedRows,
  onDelete,
  onDeactivate,
  onActivate,
  onCancel,
  onDuplicate,
  isDuplicateDisabled,
}: TableHeaderProps) => (
  <TableHeaderLayout
    selectedRows={selectedRows}
    onDeactivate={onDeactivate}
    onActivate={onActivate}
    onDuplicate={onDuplicate}
    onCancel={onCancel}
    onDelete={onDelete}
    actions={{ onDelete: true, onDuplicate: true, onDeactivate: true, onActivate: true }}
    isDuplicateDisabled={isDuplicateDisabled || selectedRows.length !== 1}
  >
    <TotalItemsLabel count={count} />
  </TableHeaderLayout>
);
